import { removeToken } from "../setup/api";

export default {
  postLogin(context) {
    return new Promise((resolve, reject) => {
      context.commit("setLoading", true);
      context
        .dispatch("user/get")
        .then(user => {
          resolve(user);
          context.commit("user/setLogged", true);
        })
        .catch(reject)
        .finally(() => {
          context.commit("setLoading", false);
        });
    });
  },

  logout(context) {
    return new Promise(resolve => {
      removeToken();
      context.commit("user/reset");
      resolve();
    });
  }
};
